import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function DesktopBanner() {
    const mediaContainerRef = useRef(null);

    const [bannerHeight, setBannerHeight] = useState(0);

    const desktopVersionStack = useSelector((state) => state.storefront.desktopVersionStack);
    const desktopVersionIndex = useSelector((state) => state.storefront.desktopVersionIndex);
    const { storefront } = useSelector((state) => state.storefront.storefront);

    useEffect(() => {
        const updateHeight = () => {
            if (mediaContainerRef.current) {
                setBannerHeight((576 / 1080) * mediaContainerRef.current.clientWidth);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (mediaContainerRef.current) {
            resizeObserver.observe(mediaContainerRef.current);
        }

        updateHeight();

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div ref={mediaContainerRef} className='w-full bg-[#868686] relative'>
            {
                desktopVersionStack[desktopVersionIndex]?.backgroundImage ? 
                <img style={{ height: `${bannerHeight}px` }} className='w-full object-cover' src={getCachedMediaUrl(desktopVersionStack[desktopVersionIndex]?.backgroundImage)} alt="" /> : 
                <div style={{ height: `${bannerHeight}px` }} className="w-full"></div>
            }

            <div className="size-[135px] absolute rounded-full overflow-hidden left-1/2 -bottom-[67.5px] -translate-x-1/2 bg-[#FFFFFF] border border-[#BFBFBF] flex items-center justify-center">
                {
                    storefront.Logo ? 
                    <img src={getCachedMediaUrl(storefront.Logo)} alt="" /> : 
                    <p className='font-semibold text-[20px] leading-[22px] text-[#1055EB]'>Add Logo</p>
                }
            </div>
        </div>
    );
}

export default DesktopBanner;
